// src/utils/resizeObserverHandler.js
const resizeObserverLoopErrRe = /^ResizeObserver loop completed with undelivered notifications.$/;

window.addEventListener('error', (e) => {
  if (resizeObserverLoopErrRe.test(e.message)) {
    e.stopImmediatePropagation();
  }
});
